import React from "react";
// Customizable Area Start
import {
  Box,
  Grid,
  Chip,
  styled
} from "@material-ui/core";

import ViewLoyaltyMultiplierController, {
  Props,
  configJSON,
} from "./ViewLoyaltyMultiplierController.web";
import { SaveAndCancelButton, HeaderText, DefultBox, InputLabel } from "../../../components/src/customComponents/CustomTags.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";

export default class ViewLoyaltyMultiplier extends ViewLoyaltyMultiplierController {
  constructor(props: Props) {
    super(props);
  }

  renderConfigFields() {
    const { multiplierRule } = this.state;
    if (!multiplierRule) return null;

    const { rule_type, config } = multiplierRule.attributes;

    switch (rule_type.id) {
      case 1:
        // Day & Time Based
        return (
          <Grid container spacing={3} style={{ display: "flex", marginTop: "16px" }}>
            <Grid item xs={12} sm={8} md={6}>
              <InputLabel>Days of Week</InputLabel>
              <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                {config.day_names?.map((day, index) => (
                  <StyledChip key={index} label={day} />
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sm={8} md={3}>
              <InputLabel>Start Time</InputLabel>
              <InfoText>{config.start_time || "N/A"}</InfoText>
            </Grid>
            <Grid item xs={12} sm={8} md={3}>
              <InputLabel>End Time</InputLabel>
              <InfoText>{config.end_time || "N/A"}</InfoText>
            </Grid>
          </Grid>
        );

      case 2:
        // Late Delivery
        return (
          <Grid container spacing={3} style={{ display: "flex", marginTop: "16px" }}>
            <Grid item xs={12} sm={8} md={6}>
              <InputLabel>Applicable Days</InputLabel>
              <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                {config.day_names?.map((day, index) => (
                  <StyledChip key={index} label={day} />
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} sm={8} md={3}>
              <InputLabel>Delay Hours</InputLabel>
              <InfoText>{config.delay_hours ? `${config.delay_hours} Hours` : "N/A"}</InfoText>
            </Grid>
          </Grid>
        );

      case 3:
        // Special Day
        return (
          <Grid container spacing={3} style={{ display: "flex", marginTop: "16px" }}>
            <Grid item xs={12} sm={8} md={4}>
              <InputLabel>Special Day Name</InputLabel>
              <InfoText>{config.special_day_name || "N/A"}</InfoText>
            </Grid>
            <Grid item xs={12} sm={8} md={4}>
              <InputLabel>Special Day Date</InputLabel>
              <InfoText>{config.formatted_date || config.special_day_date || "N/A"}</InfoText>
            </Grid>
            <Grid item xs={12} sm={8} md={4}>
              <InputLabel>Is Recurring</InputLabel>
              <InfoText>{config.is_recurring ? "Yes" : "No"}</InfoText>
            </Grid>
          </Grid>
        );

      case 4:
        // Upcharge Based
        return (
          <Grid container spacing={3} style={{ display: "flex", marginTop: "16px" }}>
            <Grid item xs={12} sm={8} md={6}>
              <InputLabel>Upcharge List</InputLabel>
              <InfoText>{config.upcharge_list_name || "N/A"}</InfoText>
            </Grid>
            <Grid item xs={12} sm={8} md={6}>
              <InputLabel>Requires All Items</InputLabel>
              <InfoText>{config.requires_all_items ? "Yes" : "No"}</InfoText>
            </Grid>
          </Grid>
        );

      default:
        return null;
    }
  }

  render() {
    const { multiplierRule, isLoading } = this.state;

    if (isLoading) {
      return <CustomLoader loading={isLoading} />;
    }

    if (!multiplierRule) {
      return (
        <Box component="div" style={webStyle.mainContainer}>
          <HeaderText style={webStyle.header}>Loyalty Multiplier Not Found</HeaderText>
        </Box>
      );
    }

    const { attributes } = multiplierRule;

    return (
      <>
        <Box component="div" sx={{...webStyle.mainContainer, width: {xs: 'calc(100% - 100px)', md: 'unset'}}}>
          <HeaderText style={webStyle.header}>View Loyalty Multiplier</HeaderText>
          <DefultBox style={webStyle.warningContainer}>
            View the details of this loyalty multiplier rule.
          </DefultBox>
          <div style={webStyle.formContainer}>
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Name */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Name</InputLabel>
                <InfoText>{attributes.name}</InfoText>
              </Grid>

              {/* Description */}
              <Grid item xs={12} sm={8} md={6}>
                <InputLabel>Description</InputLabel>
                <InfoText>{attributes.description}</InfoText>
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Multiplier */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Multiplier</InputLabel>
                <InfoText>{attributes.multiplier}x</InfoText>
              </Grid>

              {/* Rule Type */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Rule Type</InputLabel>
                <InfoText>{attributes.rule_type.name}</InfoText>
              </Grid>

              {/* Priority */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Priority</InputLabel>
                <InfoText>{attributes.priority}</InfoText>
              </Grid>

              {/* Status */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Status</InputLabel>
                <Box style={{ marginTop: "8px" }}>
                  <StyledChip
                    label={attributes.is_active ? "Active" : "Inactive"}
                    style={{
                      backgroundColor: attributes.is_active ? "rgba(76, 175, 80, 0.10)" : "rgba(244, 67, 54, 0.10)",
                      color: attributes.is_active ? "#4CAF50" : "#F44336",
                    }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Rule Type Specific Fields */}
            {this.renderConfigFields()}

            {/* Sections */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Sections</InputLabel>
                {attributes.applies_to_all_categories ? (
                  <InfoText>All Sections</InfoText>
                ) : attributes.categories.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.categories.map((category) => (
                      <StyledChip key={category.id} label={category.name} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>No Sections Selected</InfoText>
                )}
              </Grid>
            </Grid>

            {/* Products */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Products</InputLabel>
                {attributes.applies_to_all_catalogues ? (
                  <InfoText>All Products</InfoText>
                ) : attributes.catalogues.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.catalogues.map((catalogue) => (
                      <StyledChip key={catalogue.id} label={catalogue.name} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>No Products Selected</InfoText>
                )}
              </Grid>
            </Grid>

            {/* Platforms */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Platforms</InputLabel>
                {attributes.platforms && attributes.platforms.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.platforms.map((platform) => (
                      <StyledChip key={platform.id} label={platform.name} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>All Platforms</InfoText>
                )}
              </Grid>
            </Grid>

            {/* Regions */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Regions</InputLabel>
                {attributes.regions && attributes.regions.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.regions.map((region) => (
                      <StyledChip key={region.id} label={region.name || region.branch_name || `Region ${region.id}`} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>All Regions</InfoText>
                )}
              </Grid>
            </Grid>

            {/* Areas */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Areas</InputLabel>
                {attributes.areas && attributes.areas.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.areas.map((area) => (
                      <StyledChip key={area.id} label={area.area_name || area.name || `Area ${area.id}`} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>All Areas</InfoText>
                )}
              </Grid>
            </Grid>

            {/* Stores */}
            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              <Grid item xs={12}>
                <InputLabel>Stores</InputLabel>
                {attributes.stores && attributes.stores.length > 0 ? (
                  <Box style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {attributes.stores.map((store) => (
                      <StyledChip key={store.id} label={store.store_name || store.name || `Store ${store.id}`} />
                    ))}
                  </Box>
                ) : (
                  <InfoText>All Stores</InfoText>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ display: "flex", marginTop: "16px"}}>
              {/* Start Date */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>Start Date</InputLabel>
                <InfoText>{attributes.start_date}</InfoText>
              </Grid>

              {/* End Date */}
              <Grid item xs={12} sm={8} md={3}>
                <InputLabel>End Date</InputLabel>
                <InfoText>{attributes.end_date || "No End Date"}</InfoText>
              </Grid>
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "32px",
                marginBottom: "32px",
              }}
            >
              <SaveAndCancelButton
                data-test-id='back-button'
                variant='contained'
                onClick={this.handleGoBack}
                size='medium'
                style={{ ...webStyle.backButton, textTransform: "none" }}
              >
                Back
              </SaveAndCancelButton>
            </div>
          </div>
        </Box>
      </>
    );
  }
}

const InfoText = styled("div")({
  fontSize: "16px",
  lineHeight: "24px",
  color: "#000000",
  fontFamily: "Montserrat",
  fontWeight: 400,
  marginTop: "8px",
  padding: "12px 14px",
  backgroundColor: "#F8F9FA",
  borderRadius: "4px",
  minHeight: "48px",
  display: "flex",
  alignItems: "center",
});

const StyledChip = styled(Chip)({
  backgroundColor: "rgba(32, 75, 156, 0.10)",
  color: "#204B9C",
  fontFamily: "Montserrat",
  fontWeight: 500,
  fontSize: "14px",
});

const webStyle = {
  mainContainer: {
    display: "flex",
    flexDirection: "column" as const,
    fontFamily: "Montserrat",
    padding: "32px",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    maxWidth: "1200px",
  },
  header: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "29px",
    color: "#000000",
    marginBottom: "16px",
  },
  warningContainer: {
    padding: "16px",
    fontWeight: 500,
    marginTop: "32px",
    width: "100%",
    borderRadius: "4px",
    fontFamily: "Montserrat",
    borderLeft: "4px solid  #204B9C",
    background: "rgba(32, 75, 156, 0.10)",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column" as const,
    width: "100%",
  },
  backButton: {
    backgroundColor: "#204B9C",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    height: "56px",
    width: "184px",
    borderRadius: "8px",
  },
};

// Customizable Area End
